"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function CloudadministratorBlueMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#008DE5",
    d: "M13.611 7.658c.077-.275.117-.559.12-.844a2.9 2.9 0 00-2.841-2.945 2.716 2.716 0 00-.874.15 4.25 4.25 0 00-3.223-1.49 4.385 4.385 0 00-4.295 4.469c0 .207.013.415.04.62A3.51 3.51 0 000 10.996a3.476 3.476 0 003.387 3.476h9.236A3.446 3.446 0 0016 10.995a3.476 3.476 0 00-2.389-3.337zm-2.066 5.855H4.46v-.924a2.13 2.13 0 01.626-1.49 2.051 2.051 0 011.291-.6L8 12.336l1.634-1.837c.487.045.942.262 1.286.61.396.396.62.93.626 1.49v.914zm1.078 0h-.084v-.924A3.13 3.13 0 009.42 9.466h-.233L8 10.826l-1.192-1.36H6.58a3.119 3.119 0 00-3.119 3.123v.929h-.08a2.512 2.512 0 01-.203-5.006l.596-.054-.159-.576a3.476 3.476 0 01-.124-.919 3.387 3.387 0 013.302-3.476 3.253 3.253 0 012.662 1.4l.248.353.383-.204c.248-.13.524-.196.804-.193a1.902 1.902 0 011.847 1.951c0 .337-.085.669-.248.964l-.363.65.745.09a2.517 2.517 0 01-.248 5v.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CAF0FC",
    d: "M10.92 11.085c.396.395.62.93.625 1.49v.923H4.46v-.909a2.13 2.13 0 01.626-1.49 2.05 2.05 0 011.291-.6L8 12.336l1.634-1.837c.484.038.939.246 1.286.586zM9.122 7.52a1.122 1.122 0 11-2.244.049 1.122 1.122 0 012.244-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CAF0FC",
    d: "M12.871 8.512l-.745-.09.343-.645c.163-.294.249-.626.248-.963a1.902 1.902 0 00-1.847-1.952 1.703 1.703 0 00-.784.174l-.383.204-.248-.353a3.253 3.253 0 00-2.662-1.4 3.387 3.387 0 00-3.302 3.476c0 .31.042.62.124.919l.159.576-.596.054a2.513 2.513 0 00.209 5h.08v-.923a3.12 3.12 0 013.118-3.123h.228L8 10.826l1.182-1.36h.233a3.128 3.128 0 013.119 3.123v.929h.084a2.518 2.518 0 00.253-5.006zM8 9.654a2.115 2.115 0 110-4.23 2.115 2.115 0 010 4.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CAF0FC",
    fillRule: "evenodd",
    d: "M8 6.422a1.122 1.122 0 100 2.244 1.122 1.122 0 000-2.244zm2.915 4.663a2.076 2.076 0 00-1.281-.586L8 12.336l-1.624-1.837a2.05 2.05 0 00-1.291.61 2.13 2.13 0 00-.626 1.49v.924h7.086v-.934a2.13 2.13 0 00-.625-1.504h-.005z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DE5",
    d: "M8 5.429a2.115 2.115 0 100 4.23 2.115 2.115 0 000-4.23zM8 8.66a1.122 1.122 0 110-2.244A1.122 1.122 0 018 8.66z"
  }));
}

CloudadministratorBlueMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
CloudadministratorBlueMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = CloudadministratorBlueMultitoneFilled;
exports["default"] = _default;